var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{attrs:{"id":"poweredBy"}},[_vm._v("By "),_c('a',{attrs:{"href":"https://cleed.ai/","target":"_BLANK"}},[_vm._v("Cleed.ai")])])])
}]

export { render, staticRenderFns }